import RedesSociales from "../RedesSociales";
import InstagramVideoEmbed from "./InstagramEmbebed";
import styled from "styled-components";

export default function DestacadoRedes() {
  return (
    <DestacadoRedesComponent>
      <div>
        <PortadaRedes>
          <h2 className="titulo">en nuestras redes</h2>
          <p>seguinos en</p>
          <RedesSociales />
        </PortadaRedes>
        <InstagramVideoEmbed />
      </div>
    </DestacadoRedesComponent>
  );
}

const DestacadoRedesComponent = styled.div`
  margin-bottom: 4rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    width: 320px;
  }

  @media (min-width: 780px) {
    div {
      width: 100%;
    }

    > div {
      border: 1px green solid;
      border-radius: 10px;
      display: flex;
      align-items: center;
      gap: 2rem;
      width: 90%;
      padding: 1rem;
    }
    > div > h2 {
      margin-top: 6rem;
    }
  }
`;

const PortadaRedes = styled.div`
  display: flex;
  flex-direction: column;
  jusfiy-content: center;
  align-items: center;
  width: 100%;
  padding-bottom: 3rem;

  @media (min-width: 740px) {
    img {
      height: 40px;
    }
  }
`;
